import React from 'react';
import { ExternalLink, Sparkles } from 'lucide-react';

interface CreatorBacklinkProps {
  variant?: 'badge' | 'footer' | 'inline';
}

export function CreatorBacklink({ variant = 'badge' }: CreatorBacklinkProps) {
  if (variant === 'footer') {
    return (
      <div className="flex flex-wrap items-center justify-center gap-1.5 text-xs text-slate-500 dark:text-slate-400">
        <span>Designed & Built by</span>
        <a
          href="https://www.blivix.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 font-bold text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300 hover:underline transition-colors"
        >
          <span>Blivix Technologies</span>
          <ExternalLink className="w-3 h-3" />
        </a>
        <span>• 100% Client-Side Privacy</span>
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <a
        href="https://www.blivix.com"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-xs font-semibold text-indigo-600 dark:text-indigo-400 hover:underline"
      >
        <span>www.blivix.com</span>
        <ExternalLink className="w-3 h-3" />
      </a>
    );
  }

  return (
    <a
      href="https://www.blivix.com"
      target="_blank"
      rel="noopener noreferrer"
      className="group inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-white/70 dark:bg-slate-800/80 hover:bg-indigo-50 dark:hover:bg-indigo-950/60 text-slate-700 dark:text-slate-300 hover:text-indigo-600 dark:hover:text-indigo-400 border border-slate-200/80 dark:border-slate-700/80 shadow-sm transition-all duration-200"
    >
      <Sparkles className="w-3.5 h-3.5 text-indigo-500 group-hover:rotate-12 transition-transform" />
      <span>Created by <strong className="text-indigo-600 dark:text-indigo-400 group-hover:underline">Blivix</strong></span>
      <ExternalLink className="w-3 h-3 text-slate-400 group-hover:text-indigo-500 transition-colors" />
    </a>
  );
}
